import React, { useMemo, useState } from 'react';
import { EventInterface } from './FutureEvents';

interface PastEventsInterface {
    pastEvents: EventInterface[];
};

function PastEvent ({ name, timeText, location, link }: EventInterface) {
    return (
        <div className="pastEventsEventWrapper">
            <div className="pastEventsEventName">{name}</div>
            <div className="pastEventsEventTime">{timeText}</div>
            <div className="pastEventsEventLocation">{location}</div>
        </div>
    );
}

function PastEvents({pastEvents}: PastEventsInterface) {
    const [showPartialList, setShowPartialList] = useState(true);

    const futureEventsFinal = useMemo(() => {
            if (showPartialList) {
                return pastEvents.slice(0, 2);
            }
            return pastEvents;
        }, [showPartialList, pastEvents]);
    
        const handleShowMoreLessClick = () => {
            setShowPartialList(!showPartialList);
        }

    return (
        <div className="pastEventsWrapper">
            <div className="pastEventsTitle">PAST EVENTS</div>
            <div className="pastEventsListWrapper">
                {futureEventsFinal.map((pastEvent, idx) =>
                    <PastEvent key={idx} name={pastEvent.name} description={pastEvent.description} timeEnd={pastEvent.timeEnd} timeText={pastEvent.timeText} location={pastEvent.location} link={pastEvent.link}/>
                )}
            </div>
            <button className="pastEventsShowMoreLessButton"onClick={handleShowMoreLessClick}>{showPartialList ? "SHOW MORE" : "SHOW LESS"}</button>
        </div>
    )
}

export default PastEvents;